export default __webpack_public_path__ + "static/media/diem-den-pho-bien-01.73404b25.png";